export default "__VITE_ASSET__B3IFbP75__"